import ShippingDocument from '../../models/ShippingDocument'

export const ShippingDocumentModule = {
  namespaced: true,

  state: {
    shippingDocument: new ShippingDocument({})
  },

  getters: {
    shippingDocument (state) {
      return state.shippingDocument
    }
  },

  mutations: {
    setShippingDocument (state, shippingDocument = null) {
      state.shippingDocument = new ShippingDocument(shippingDocument)
    }
  }
}

export default ShippingDocumentModule
